export default __webpack_public_path__ + "static/screeny-110-gc-1-85b31d8f7051fcc0ca38c4f11644874b.jpg";